import { render, staticRenderFns } from "./CommonFooter.vue?vue&type=template&id=3e13756e&scoped=true"
import script from "./CommonFooter.vue?vue&type=script&lang=js"
export * from "./CommonFooter.vue?vue&type=script&lang=js"
import style0 from "./CommonFooter.vue?vue&type=style&index=0&id=3e13756e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e13756e",
  null
  
)

export default component.exports